import React, { useEffect } from 'react';
import lottie from 'lottie-web';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Summary, Button } from '@sololearnorg/sol';

import { i18n } from '../../../symphony';

import heartsRefill from './hearts-refill.json';

import s from './SlFreeHeartScreen.scss';

export interface ISlFreeHeartsScreenProps {
    onFreeRefill: () => void;
}

export const SlFreeHeartScreen: React.FC<ISlFreeHeartsScreenProps> = React.memo(
	({ onFreeRefill }) => {
		useStyles(s);

		useEffect(() => {
			lottie.loadAnimation({
				animationData: heartsRefill,
				container: document.getElementById(
					'freeHeartsScreen__animation',
				),
				autoplay: true,
				loop: false,
			});
		}, []);

		return (
			<div className="freeHeartsScreen__summary">
				<Summary
					illustration={(
						<div
							className="freeHeartsScreen__animation"
							id="freeHeartsScreen__animation"
						/>
					)}
					headline={(
						<div className="freeHeartsScreen__headline">
							<p>{i18n.t('web-hearts.free-refill-headline1')}</p>
							<p>{i18n.t('web-hearts.free-refill-headline2')}</p>
						</div>
					)}
					description={(
						<>
							<p>
								{i18n.t('web-hearts.free-refill-description1')}
							</p>
							<p>
								{i18n.t('web-hearts.free-refill-description2')}
							</p>
						</>
					)}
					actionBar
					actions={[
						<Button
							key="Refill"
							onClick={onFreeRefill}
						>
							{i18n.t('web-hearts.free-refill-cta')}
						</Button>,
					]}
				/>
			</div>
		);
	},
);
